/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
// eslint-disable-next-line import/extensions
import axios from 'axios';
import * as actionTypes from './ActionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

// Search criteria list
export const dispatchCmsRosiCriteriaList = (data) => ({
  type: actionTypes.GET_CMS_ROSI_BY_CRITERIA,
  searchInvoiceByCriteriaList: data,
});

// dispatch save Update
export const dispatchSaveUpdate = (data) => ({
  type: actionTypes.CMS_UPDATE_STATE,
  saveUpdateState: data,
});

// dispatch success message
export const handleSuccessMessages = (data) => ({
  type: actionTypes.HANDLE_SUCCESS_MESSAGE_FOR_CMS_ROSI,
  successMessageInRedux: data,
});

// dispatch all ndc
export const dispatchAllNDCForLabeller = (data) => ({
  type: actionTypes.GET_UC_NDC_BY_LABELLER,
  ndcListFromLabeller: data,
});

// dispatch manufacturer
export const dispatchManufacturerData = (data) => ({
  type: actionTypes.GET_MANUFACTURER_DATA,
  manufacturerList: data,
});

// dispatch cleared index
export const dispatchUpdateAuditClearedIndex = (data) => ({
  type: actionTypes.UPDATE_AUDIT_CLEARED_INDEX_DATA,
  auditClearedIndexData: data,
});

// dispatch search criteria list
export const dispatchCmsRosiCriteria = (data) => ({
  type: actionTypes.GET_SEARCH_CMS_ROSI_BY_CRITERIA_LIST,
  searchCmsRosiByCriteriaList: data,
});

// api for rosi by criteria
export const getCmsRosiByCriteria = (value) => (dispatch) => {
  dispatch(dispatchCmsRosiCriteria(value));
  return axios
    .post(serviceEndPoint.GET_CMS_ROSI_BY_CRITERIA_LIST, value)
    .then((response) => {
      return dispatch(
        dispatchCmsRosiCriteriaList(response.data && response.data)
      );
    })
    .catch(() => {
      dispatch(dispatchCmsRosiCriteriaList([]));
    });
};

// api get ndc by lableler
export const getNDCByLabeller = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_NDC_LIST_BY_LABELER, values)
    .then((response) => {
      dispatch(dispatchAllNDCForLabeller(response.data));
    })
    .catch(() => {
      dispatch(dispatchAllNDCForLabeller({ error: 'API failed' }));
    });
};

// update api for cleared index
export const updateAuditClearedIndex = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_ROSI_AUDIT_CLEARED_INDEX, value)
    .then((response) => {
      return dispatch(dispatchUpdateAuditClearedIndex(response.data));
    })
    .catch(() => {
      dispatch(dispatchUpdateAuditClearedIndex([]));
    });
};

// api for get manufacturer list
export const getManufacturerList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MANUFACTURER_DETAILS, value)
    .then((response) => {
      return dispatch(
        dispatchManufacturerData(response.data && response.data.data)
      );
    })
    .catch(() => {
      dispatch(dispatchManufacturerData([]));
    });
};

// search rosi tab data
export const setSearchCmsRosiTab = (data) => {
  return {
    type: actionTypes.SEARCH_CMS_ROSI_TAB_DATA,
    searchCmsRosiObj: data,
  };
};
// set rosi tab details
export const setCmsRosiDetailTab = (data) => {
  return {
    type: actionTypes.CMS_ROSI_DETAIL_TAB_DATA,
    cmsRosiDetailObj: data,
  };
};

// dispatch plan type filtered data
export const dispatchPlanTypeFilterData = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA,
  checkbox: data,
});

// get checkbox statuts
export const getCheckBoxValue = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanTypeFilterData(response.data));
    })
    .catch(() => {
      dispatch(dispatchPlanTypeFilterData([]));
    });
};

// dispatch dropdown data
export const dispatchCommonDropdownData = (data) => ({
  type: actionTypes.GET_COMMON_DROPDOWN_DATA,
  dropdown: data,
});

// api for get dropdown list
export const getCommonDropdownList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};

// dispatch qarter data
export const dispatchQuarterData = (data) => ({
  type: actionTypes.GET_QUARTER_DATA,
  quarter: data,
});

// api call for quarter data
export const getQuarterData = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_QUARTER_DATA)
    .then((response) => {
      return dispatch(dispatchQuarterData(response.data));
    })
    .catch(() => {
      dispatch(dispatchQuarterData([]));
    });
};

// dispatch error messages
export const handleErrorMessages = (data) => ({
  type: actionTypes.HANDLE_ERROR_MESSAGE_FOR_CMS_ROSI,
  errorMessagesInRedux: data,
});

// dispatch audit types drop down list data
export const dispatchAuditTypeDropDownList = (data) => ({
  type: actionTypes.GET_AUDIT_TYPE_CMS_CD,
  auditTypeList: data,
});

// api call for get audit type dropdown
export const getAuditTypeDropDownList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_AUDIT_TYPE_LIST, value)
    .then((response) => {
      return dispatch(
        dispatchAuditTypeDropDownList(
          response.data && response.data.invoiceAuditResponse
        )
      );
    })
    .catch(() => {
      dispatch(dispatchAuditTypeDropDownList([]));
    });
};

// dispatch selected row data
export const dispatchSelectedRowData = (data) => ({
  type: actionTypes.GET_SELECTED_ROW_DATA,
  selectedRowData: data,
});

// dispatch comments corr links id
export const getExistingCorrLinkIds = (value) => {
  return axios
    .post(serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};

// clear redux
export const clearReduxForCmsRosiSearchScrren = () => (dispatch) => {
  dispatch(setSearchCmsRosiTab({}));
  dispatch(dispatchPlanTypeFilterData([]));
  dispatch(dispatchAuditTypeDropDownList([]));
  dispatch(dispatchCmsRosiCriteriaList({}));
  dispatch(dispatchCmsRosiCriteria({}));
};

export const clearReduxForCmsRosiDetailsScrren = () => (dispatch) => {
  dispatch(setSearchCmsRosiTab({}));
  dispatch(handleSuccessMessages([]));
};
